import React from 'react';

import DraftOrderStatusPills from './DraftOrderStatusPills';
import { formatDate, formatDateOnly, useFormatUSD } from '../../../utils/formatting';

function DraftOrderHeader({ draftOrder, expired, expirationColorClass, expirationText, expirationTextClass, onClick = null }) {
  if (!draftOrder) return null;

  const order = draftOrder.order;
  const isOrder = order?.id;
  // const createdAt = isOrder ? order.createdAt : draftOrder.createdAt;
  const total = isOrder ? order.totalPrice : draftOrder.totalPrice;
  const showExpired = !isOrder && expired;

  return (
    <div className="draft-order-header" >
      <div className="draft-order-title">

        <h2 className="heading heading--h2" onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }}>
          {isOrder ? (
            <>Order {draftOrder.order?.name}<span className="quote-number">&nbsp;-&nbsp;(Quote {draftOrder.name})</span></>
          ) : (
            'Quote ' + draftOrder.name
          )}
        </h2>

        <DraftOrderStatusPills
          draftOrder={draftOrder}
          expired={showExpired}
          expirationColorClass={expirationColorClass}
          expirationText={expirationText}
        />

        
      </div>


      <div className="draft-order-total">
        
        <div className="total-amount">
          Total: <strong className="total-amount-value">{useFormatUSD(total)}</strong>
        </div>

        <div className="draft-order-meta">
          {draftOrder.order?.createdAt && (
            <div className="created-on">Order Created: <span className="date-value">{formatDate(draftOrder.order.createdAt)}</span></div>
          )}

          <div className="created-on">Quote Created: <span className="date-value">{formatDate(draftOrder.createdAt)}</span></div>

          {!isOrder && draftOrder.expirationDate && (
            <div className="expiration-date">Quote Expiration: <span className={`date-value ${expirationTextClass}`}>{formatDate(draftOrder.expirationDate)}</span></div>
          )}
        </div>

      </div>
    </div>
  );
}

export default DraftOrderHeader;